/**
 * Le curseur « Distance max. » des cartes de formateurs : la carte de la liste
 * des formateurs et celle du Point de vigilance de l'analyse du besoin. Une
 * seule source, pour que les deux cartes règlent la même distance de la même
 * façon.
 */
export const RAYON_MIN_KM = 5
export const RAYON_MAX_KM = 300
export const RAYON_PAS_KM = 5
export const RAYON_DEFAUT_KM = 50
